

export function numberWithCommas(x: number, idx: number=2): string {
  return x?.toFixed(idx).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function bindDecimalPlaces(x: number, idx: number = 2): number {
  return parseFloat(x?.toFixed(idx)); 
}